<script>
export default {
  name: 'ContentBranchCard',
  props: { node: { type: Object, required: true } },
  data: () => ({ imageFailed: false }),
  computed: { imageUrl() { return this.node.image_url || this.node.image; } },
  watch: { imageUrl() { this.imageFailed = false; } },
};
</script>
<template>
  <router-link :to="node.url" class="branch-card" :data-branch-id="node.id">
    <div class="branch-card__image">
      <img v-if="imageUrl && !imageFailed" :src="imageUrl" :alt="node.title" loading="lazy" @error="imageFailed = true" />
      <div v-else class="branch-card__empty" aria-hidden="true"><i class="pi pi-book"></i></div>
    </div>
    <div class="branch-card__body">
      <h3>{{ node.title }}</h3>
      <span class="branch-card__action">عرض المحتوى <i class="pi pi-arrow-left" aria-hidden="true"></i></span>
    </div>
  </router-link>
</template>
<style scoped>
.branch-card { display: flex; flex-direction: column; min-width: 0; border: 1px solid #94a3b844; border-radius: 1rem; overflow: hidden; color: var(--tree-text); background: var(--tree-surface); text-decoration: none; box-shadow: 0 4px 18px #17203308; transition: border-color .15s, box-shadow .15s; }
.branch-card:hover, .branch-card:focus-visible { border-color: var(--tree-accent); box-shadow: 0 5px 22px #17203318; }
.branch-card:focus-visible { outline: 2px solid var(--tree-accent); outline-offset: 3px; }
.branch-card__image { position: relative; aspect-ratio: 16 / 10; flex-shrink: 0; background: #94a3b812; }
.branch-card__image img { position: absolute; inset: 0; display: block; width: 100%; height: 100%; object-fit: contain; }
.branch-card__empty { position: absolute; inset: 0; display: grid; place-items: center; color: var(--tree-accent); }
.branch-card__empty i { font-size: 3rem; }
.branch-card__body { display: flex; flex: 1; flex-direction: column; gap: 1rem; padding: 1.1rem; }
h3 { margin: 0; font-size: 1.15rem; font-weight: 700; line-height: 1.6; overflow-wrap: anywhere; }
.branch-card__action { display: flex; align-items: center; justify-content: space-between; gap: .75rem; margin-top: auto; font-size: .9rem; font-weight: 600; color: var(--tree-accent); }
</style>
